import React from "react";
import { Helmet } from "react-helmet-async";
import { Mail, MapPin, Clock, Heart } from "lucide-react";

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact Monica Korba | End-of-Life Doula Columbia, MO | Serenity Passage</title>
        <meta
          name="description"
          content="Contact Monica Korba for compassionate end-of-life doula services in Columbia, Missouri. Schedule your free 30-minute consultation for hospice support in Mid-Missouri."
        />
        <meta
          name="keywords"
          content="contact end-of-life doula Columbia MO, death doula Columbia Missouri, schedule consultation Mid-Missouri, Monica Korba"
        />
        <link rel="canonical" href="https://www.serenitypassage.net/contact" />
      </Helmet>

      {/* Hero Banner */}
      <section className="bg-gradient-to-b from-rose-100 to-rose-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl sm:text-5xl font-serif text-gray-800 text-center mb-4">
            Let's Connect
          </h1>
          <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto">
            I would be honored to support you and your family during this time. Your first 30-minute consultation is complimentary.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div>
              <h2 className="text-2xl font-serif text-gray-800 mb-8">Get in Touch</h2>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="bg-rose-100 p-3 rounded-full">
                    <Mail className="w-6 h-6 text-rose-600" />
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-800 mb-1">Email</h3>
                    <a
                      href="mailto:mokorba@gmail.com"
                      className="text-rose-600 hover:text-rose-700 transition-colors"
                      data-testid="contact-email"
                    >
                      mokorba@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-rose-100 p-3 rounded-full">
                    <MapPin className="w-6 h-6 text-rose-600" />
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-800 mb-1">Service Area</h3>
                    <p className="text-gray-600">Mid-Missouri</p>
                    <p className="text-gray-500 text-sm">In-person and virtual support available</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-rose-100 p-3 rounded-full">
                    <Clock className="w-6 h-6 text-rose-600" />
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-800 mb-1">Availability</h3>
                    <p className="text-gray-600">Flexible scheduling</p>
                    <p className="text-gray-500 text-sm">Available for urgent support needs</p>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA Card */}
            <div className="bg-gradient-to-br from-rose-50 to-rose-100 rounded-2xl p-8">
              <div className="flex items-center gap-3 mb-6">
                <Heart className="w-8 h-8 text-rose-600" />
                <h2 className="text-2xl font-serif text-gray-800">Free Consultation</h2>
              </div>
              
              <p className="text-gray-700 mb-6 leading-relaxed">
                Your first 30-minute consultation is complimentary. This is an opportunity for us to connect, discuss your situation, and explore how I might support you and your family.
              </p>

              <p className="text-gray-700 mb-8 leading-relaxed">
                There's no obligation and no pressure. I'm simply here to listen and help you understand your options.
              </p>

              <a
                href="mailto:mokorba@gmail.com?subject=Consultation%20Request%20-%20Serenity%20Passage"
                className="inline-flex items-center justify-center gap-2 w-full bg-rose-600 hover:bg-rose-700 text-white px-8 py-4 rounded-full font-medium transition-colors duration-200 shadow-lg hover:shadow-xl"
                data-testid="email-cta"
              >
                <Mail className="w-5 h-5" />
                Email Monica
              </a>
            </div>
          </div>

          {/* Quote */}
          <div className="mt-16 text-center">
            <blockquote className="text-xl text-gray-700 italic max-w-2xl mx-auto">
              "I believe in walking beside you with compassion, presence, and unwavering support during this sacred time."
            </blockquote>
            <p className="mt-4 text-gray-600 font-medium">Monica Korba, RN</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
